import React from "react";
import VqqSectionAccordion from "./VqqSectionAccordion";

/**
 * Renders every section as an accordion. The sidebar scrolls the user to
 * the matching section instead of switching which one is visible.
 *
 * 14030 — scoredRowsByQuestionId + methodology are threaded down to each
 * question card so the per-question Risk Panel can render I/L/D + severity
 * + citations + methodology tooltips. aggregatesBySection drives the
 * section header badges. All default to null for non-entitled viewers so
 * the panel silently disappears (gating happens upstream).
 */
const VqqSectionView = ({
  sections,
  openSet,
  onToggle,
  registerRef,
  scoredRowsByQuestionId = null,
  methodology = null,
  aggregatesBySection = null,
  isAdmin = false,
  mode = null,
  missingGapTextIds = null,
  onSmeSave = null,
}) => {
  if (!sections || sections.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded p-6 text-sm text-gray-500">
        No sections to display.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {sections.map((section) => (
        <VqqSectionAccordion
          key={section.section}
          ref={(node) => registerRef(section.section, node)}
          section={section}
          isOpen={openSet.has(section.section)}
          onToggle={() => onToggle(section.section)}
          scoredRowsByQuestionId={scoredRowsByQuestionId}
          methodology={methodology}
          aggregate={aggregatesBySection?.get(section.section)}
          isAdmin={isAdmin}
          mode={mode}
          missingGapTextIds={missingGapTextIds}
          onSmeSave={onSmeSave}
        />
      ))}
    </div>
  );
};

export default VqqSectionView;
